module.exports = __webpack_public_path__ + "images/abarth_small552821b723056fccf9de01a346ccd52f.png";